import { cn } from '@ludus/ui'
import type { ManagerId } from '../../types.ts'
import { ManagerPicker } from './ManagerPicker.tsx'
import { MiniCalendar } from './MiniCalendar.tsx'

interface SidebarProps {
  visibleDate: Date
  selectedManagerId: ManagerId | null
  onDateSelect: (d: Date) => void
  onManagerSelect: (id: ManagerId) => void
  className?: string
}

export function Sidebar({
  visibleDate,
  selectedManagerId,
  onDateSelect,
  onManagerSelect,
  className,
}: SidebarProps) {
  return (
    <aside
      className={cn(
        'flex w-64 shrink-0 flex-col gap-3 overflow-y-auto rounded-lg border border-border/60 bg-background-app py-3',
        className,
      )}
    >
      <MiniCalendar visibleDate={visibleDate} onSelect={onDateSelect} />
      <div className="border-t border-border/60" />
      <ManagerPicker selectedId={selectedManagerId} onSelect={onManagerSelect} />
    </aside>
  )
}
